// if (window.location.pathname === "/collections/crossword-gift-vouchers") {
//   window.location.href = "https://www.crossword.in/collections/gift-cards";
// }

// let collectionsWithRank = new Map([
//   // ['new-noteworthy-2', 50],
//   // ['new-noteworthy-fiction-2', 50],
//   // ['new-noteworthy-non-fiction-2', 50],
//   // ['new-noteworthy-business-management-1', 50],
//   // ['new-noteworthy-kids-3', 50],
//   // ['new-noteworthy-young-adults-1', 50],
//   // ['top-51', 50],
//   // ['new-noteworthy-fiction-2', 50],
//   // ['non-fiction-top-51', 50],
//   // ['business-management-top-50', 50],
//   // ['kids-top-51', 50],
//   // ['young-adults-top-51', 50],
//   // ['crossword-recommends', 50],
//   // ['books', 50],
//   // ['fiction', 50],
//   // ['non-fiction-1', 50],
//   // ['business-management-1', 50],
//   // ['kids-books', 50],
//   // ['young-adult', 50],
//   // ['general-and-literary-fiction', 50],
//   // ['fiction-top-51', 50]
// ]);

function extractCollectionName(url) {
  // Define a regular expression pattern to match the collection name
  const pattern = /\/collections\/([^?/]+)/;

  // Use the RegExp.exec method to extract the collection name
  const matches = pattern.exec(url);

  // Check if there is a match and return the collection name (group 1 in the regex match)
  if (matches && matches[1]) {
    return matches[1];
  } else {
    // Return a default value or handle the case where the pattern doesn't match
    return null;
  }
}

function findProductRank(value) {
  const len = value.length;
  if (len > 3) {
    const number = value[len - 3] + value[len - 2] + value[len - 1];
    // console.log(number);
    return parseInt(number, 10);
  }

  return NaN;
}

window.onWizzyScriptLoaded = function () {
  if(window.innerWidth < 769)
  {
    let search_icon = document.querySelector('.wz-search-icon');
    if(search_icon)
    {
      search_icon.addEventListener('click', function(){
        setTimeout(() => {
          let search_bar = document.querySelector('.search-bar input');
          if(search_bar)
          {
            search_bar.click();
          }
        }, 500);
      })
    }
  }
  const targetNode = document.querySelector(".wizzy-body-end-wrapper");
  function updateBodyClass() {
    const autocompleteElement = targetNode.querySelector(
      ".wizzy-autocomplete-wrapper"
    );
    autocompleteElement &&
    window.getComputedStyle(autocompleteElement).display === "flex"
      ? document.body.classList.add("wizzy-autocomplete-open")
      : document.body.classList.remove("wizzy-autocomplete-open");
    if (autocompleteElement) {
      if (window.getComputedStyle(autocompleteElement).display === "flex") {
        document.documentElement.classList.add("wizzy-autocomplete-open");
      } else {
        document.documentElement.classList.remove("wizzy-autocomplete-open");
      }

      if (window.innerWidth > 768) {
        const search = document.querySelector(".search-bar");
        const auto = document.querySelector(".wizzy-autocomplete-wrapper");
        

        if (!search || !auto) return;
        const rect = search.getBoundingClientRect();
        if (window.innerWidth > 768) {
          auto.style.width = search.offsetWidth + "px";
          // auto.style.top = (rect.bottom + 3) + "px";
        } else {
          auto.style.width = "";
        }
        // if(window.scrollY > 30)
        // {
        //   autocompleteElement.style.setProperty("top", "80px", "important");
        // }
        // else
        // {
        //   autocompleteElement.style.setProperty("top", "120px", "important");
        // }
      } else {
        document.documentElement.classList.remove("wizzy-autocomplete-open");
        if (window.scrollY > 30) {
          autocompleteElement.style.setProperty("top", "65px", "important");
        }
        else
        {
          autocompleteElement.style.setProperty("max-height", "calc(100% - 110px)", "important");
        }
      }
    }
  }
  const config = {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"],
    },
    callback = function (mutationsList, observer2) {
      for (const mutation of mutationsList) {
        updateBodyClass();
        break;
      }
    },
    observer = new MutationObserver(callback);
  targetNode && (observer.observe(targetNode, config), updateBodyClass());

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      if (data.filters.type == "AUTOCOMPLETE_DEFAULT") {
        data.filters.sort = [
          {
            field: "relevance",
            order: "asc",
          },
          {
            field: "product_top-6_sortOrder:float",
            order: "asc",
          },
        ];
      }
      const alreadyExists1 = data.filters?.sort?.some(
          (s) =>
              s.field === "product_wizzy-best-selling_sortOrder:float" &&
              s.order === "asc"
      );

      if (
          !alreadyExists1 &&
          data.filters?.sort?.[0]?.field === "relevance"
      ) {
          data.filters.sort.push({
              field: "product_wizzy-best-selling_sortOrder:float",
              order: "asc"
          });
      }
      return data;
    }
  );

  // Removing price filter from gift-cards collection
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log("Gift-card ==>",payload);
      // console.log(wizzyConfig.common.collectionHandle==='gift-cards');
      // console.log("BEFORE_RENDER_RESULTS", payload);
      // console.log("BEFORE_RENDER_RESULTS", payload);
      if(window.innerWidth < 769)
      {
        if(payload?.response?.payload?.total === 0 && Array.isArray(payload?.response?.payload?.result) && payload?.response?.payload?.result?.length === 0)
        {
          let bottom_fs = document.querySelector('.wz-mobile-bottom-filter-sort');
          // console.log("bottom_fs", bottom_fs);
          if(bottom_fs)
          {
            bottom_fs.classList.add('wz-on-404');
          }
        }
        else
        {
          let bottom_fs = document.querySelector('.wz-mobile-bottom-filter-sort');
          // console.log("bottom_fs", bottom_fs);
          if(bottom_fs)
          {
            bottom_fs.classList.remove('wz-on-404');
          }
        }
      }
      
      let facets = payload?.response?.payload?.facets;
      // if(facets)
      // {
      //   // facets.forEach((facet) => {
      //   //   facet.position = 'top';
      //   //   if(facet.key === "product_value_tags_genre")
      //   //   {
      //   //     facet.order = 1;
      //   //   }
      //   //   else if(facet.key === "sellingPrice")
      //   //   {
      //   //     facet.order = 2;
      //   //   }
      //   //   else if(facet.key === "product_books_author_1_custom")
      //   //   {
      //   //     facet.order = 3;
      //   //   }
      //   //   else if(facet.key === "product_books_language_custom")
      //   //   {
      //   //     facet.order = 4;
      //   //   }
      //   // }
      //     const allowedFacets = {
      //       product_value_tags_genre: 1,
      //       sellingPrice: 2,
      //       product_books_author_1_custom: 3,
      //       product_books_language_custom: 4
      //     };

      //     facets = facets
      //       .filter(facet => allowedFacets.hasOwnProperty(facet.key))
      //       .map(facet => {
      //         // facet.position = 'top';
      //         facet.order = allowedFacets[facet.key];
      //         return facet;
      //       });
      // }
      if (wizzyConfig.common.collectionHandle === "gift-cards") {
        payload.response.payload.facets =
          payload.response.payload.facets.filter(
            (facet) => facet.label !== "Price"
          );
      }
      return payload;
    }
  );
  let wizzyEvents2 = function () {
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (data) {
        // console.log("event1");
        return data;
      }
    );
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (data) {
        // console.log("event2");
        return data;
      }
    );
  };
  // window.iWishData.iwish_add_txt_col = `
  //   <svg class="wish wishlist-icon " width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  //               <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="white"></rect>
  //               <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="black"></rect>
  //               <path d="M31.3671 17.8417C30.9415 17.4159 30.4361 17.0781 29.8799 16.8476C29.3237 16.6171 28.7275 16.4985 28.1254 16.4985C27.5234 16.4985 26.9272 16.6171 26.371 16.8476C25.8147 17.0781 25.3094 17.4159 24.8838 17.8417L24.0004 18.725L23.1171 17.8417C22.2573 16.9819 21.0913 16.499 19.8754 16.499C18.6596 16.499 17.4935 16.9819 16.6338 17.8417C15.774 18.7014 15.291 19.8675 15.291 21.0834C15.291 22.2992 15.774 23.4653 16.6338 24.325L17.5171 25.2084L24.0004 31.6917L30.4838 25.2084L31.3671 24.325C31.7929 23.8994 32.1307 23.394 32.3612 22.8378C32.5917 22.2816 32.7103 21.6854 32.7103 21.0834C32.7103 20.4813 32.5917 19.8851 32.3612 19.3289C32.1307 18.7727 31.7929 18.2673 31.3671 17.8417Z" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
  //             </svg>`;
  // window.iWishData.iwish_added_txt_col = `
  //   <svg class="wishlist-svg" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  //                 <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="white"></rect>
  //                 <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="black"></rect>
  //                 <path d="M31.3671 17.8417C30.9415 17.4159 30.4361 17.0781 29.8799 16.8476C29.3237 16.6171 28.7275 16.4985 28.1254 16.4985C27.5234 16.4985 26.9272 16.6171 26.371 16.8476C25.8147 17.0781 25.3094 17.4159 24.8838 17.8417L24.0004 18.725L23.1171 17.8417C22.2573 16.9819 21.0913 16.499 19.8754 16.499C18.6596 16.499 17.4935 16.9819 16.6338 17.8417C15.774 18.7014 15.291 19.8675 15.291 21.0834C15.291 22.2992 15.774 23.4653 16.6338 24.325L17.5171 25.2084L24.0004 31.6917L30.4838 25.2084L31.3671 24.325C31.7929 23.8994 32.1307 23.394 32.3612 22.8378C32.5917 22.2816 32.7103 21.6854 32.7103 21.0834C32.7103 20.4813 32.5917 19.8851 32.3612 19.3289C32.1307 18.7727 31.7929 18.2673 31.3671 17.8417Z" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" fill="black"></path>
  //               </svg>`;
  window.onWizzyLoaded.push(wizzyEvents2);
  let wizzyEvents1 = function () {
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (data) {
        // console.log("event3");
        return data;
      }
    );
    // function isInWishlist(vId) {
    //   return window.iWish.iWishlist.has(vId) ? true : false;
    // }
    function initWizzyQuickProductTypeFilters() {
      const oldWrapper = document.querySelector(".wizzy-quick-filters-wrapper");
      oldWrapper && oldWrapper.remove();

      const facetBlock = document.querySelector(
        ".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block[data-key='product_producttype_custom']"
      );
      if (!facetBlock) {
        // console.log("Returning");
        return;
      }

      const facetItems = facetBlock.querySelectorAll(
        ".wizzy-facet-list .facet-item-label-value"
      );
      if (!facetItems) {
        // console.log("Returning 2");
        return;
      }

      const selectedItems = document.querySelectorAll(
        ".wizzy-selected-facet-list li"
      );
      const selectedMap = {};

      selectedItems.forEach((li) => {
        const key = li.getAttribute("data-facetkey");
        const value = li.getAttribute("title")?.trim();
        if (!key || !value) return;

        if (!selectedMap[key]) selectedMap[key] = [];
        selectedMap[key].push(value);
      });

      const selectedProductTypes =
        selectedMap["product_producttype_custom"] || [];

      const quickWrapper = document.createElement("div");
      quickWrapper.className = "wizzy-quick-filters-wrapper";

      facetItems.forEach((facetItem) => {
        const label = facetItem.textContent.trim();
        if (!label) return;

        const quickItem = document.createElement("div");
        quickItem.className = "wizzy-quick-filter-item";
        quickItem.textContent = label;

        if (selectedProductTypes.includes(label)) {
          quickItem.classList.add("selected");
        }

        quickItem.addEventListener("click", (e) => {
          const isMobile = window.innerWidth <= 768;

          e.preventDefault();
          e.stopPropagation();

          quickWrapper
            .querySelectorAll(".wizzy-quick-filter-item")
            .forEach((el) => el.classList.remove("selected"));

          quickItem.classList.add("selected");

          facetItem.click();

          if (isMobile) {
            const facetHead = document.querySelector(
              ".wizzy-facet-head.facet-head-product_producttype_custom"
            );
            if (facetHead) facetHead.click();
          }
        });

        quickWrapper.appendChild(quickItem);
      });

      // ONLY CHANGE: insert as FIRST element inside .search-filters-top-wrapper
      const filtersTopWrapper = document.querySelector(
        ".search-filters-top-wrapper"
      );
      if (filtersTopWrapper) {
        filtersTopWrapper.prepend(quickWrapper);
      }
    }
    function renderGenreTagsFromFacets() {
        try {
            // facet block
            const facetBlock = document.querySelector(
                '.wizzy-filters-facet-block[data-key="product_primary_genre_custom"]'
            );
            if (!facetBlock) return;

            // facet items
            const listItems = facetBlock.querySelectorAll(
                ".wizzy-facet-body .wizzy-facet-list li"
            );
            if (!listItems || !listItems.length) return;

            // target container
            const container = document.querySelector(".collection-tags");
            if (!container) return;

            // reset
            container.innerHTML = "";
            container.classList.remove("left", "centered");

            // render tags (max 10)
            let renderedCount = 0;

            Array.from(listItems).some(li => {
                if (renderedCount >= 10) return true;

                if (!li || !li.getAttribute) return false;

                const term = li.getAttribute("data-term");
                if (!term) return false;

                const btn = document.createElement("button");
                btn.className = "collection-tag-btn";
                btn.textContent = term;

                btn.addEventListener("click", e => {
                    e.preventDefault();
                    window.location.href = `/pages/search?q=${encodeURIComponent(term)}`;
                });

                container.appendChild(btn);
                renderedCount++;

                return false;
            });

            // nothing rendered → exit
            if (!container.children.length) return;

            // align after layout
            requestAnimationFrame(() => {
                if (!container || !container.clientWidth) return;

                let childrenWidth = 0;

                Array.from(container.children).forEach(el => {
                    if (!el || typeof el.offsetWidth !== "number") return;
                    childrenWidth += el.offsetWidth;
                });

                if (childrenWidth > container.clientWidth) {
                    container.classList.add("left");
                    container.classList.remove("centered");
                } else {
                    container.classList.add("centered");
                    container.classList.remove("left");
                }
            });

        } catch (err) {
            // silent fail – prevents UI break
            // console.warn("renderGenreTagsFromFacets failed safely", err);
        }
    }

    // function renderGenreTagsFromFacets() {
    //   // if (!document.body.classList.contains('wizzy-collection')) return;

    //   const facetBlock = document.querySelector(
    //     '.wizzy-filters-facet-block[data-key="product_primary_genre_custom"]'
    //   );
    //   if (!facetBlock) return;

    //   const listItems = facetBlock.querySelectorAll(
    //     ".wizzy-facet-body .wizzy-facet-list li"
    //   );

    //   const container = document.querySelector(".collection-tags");
    //   if (!container) return;

    //   container.innerHTML = "";

    //   Array.from(listItems)
    //     .slice(0, 10) // 👈 only first 10
    //     .forEach((li) => {
    //       const term = li.getAttribute("data-term");
    //       if (!term) return;

    //       const btn = document.createElement("button");
    //       btn.className = "collection-tag-btn";
    //       btn.textContent = term;

    //       // btn.addEventListener('click', () => {
    //       //   const checkbox = li.querySelector('input[type="checkbox"]');
    //       //   checkbox && checkbox.click();
    //       // });
    //       btn.addEventListener("click", (e) => {
    //         e.preventDefault();

    //         const term = li.getAttribute("data-term");
    //         window.location.href = `/pages/search?q=${encodeURIComponent(
    //           term
    //         )}`;
    //       });

    //       container.appendChild(btn);
    //     });
    // }

    document.addEventListener("click", function (e) {
      // console.log("target======>", e.target);
      const clearIcon = e.target.closest(".wizzy-recent-search-clear-icon");
      if (!clearIcon) return;

      const link = clearIcon.closest(".autocomplete-link");
      if (!link) return;

      const searchTerm = link.getAttribute("data-searchterm");
      if (!searchTerm) return;

      const storeRaw = localStorage.getItem("wizzy_store");
      if (!storeRaw) return;

      let wizzyStore;
      try {
        wizzyStore = JSON.parse(storeRaw);
      } catch (e) {
        // console.warn("wizzy_store JSON invalid", e);
        return;
      }

      const list = wizzyStore.SEARCHED_TERM;
      if (!Array.isArray(list)) return;

      // normalize to compare fairly
      const target = searchTerm.toLowerCase();

      // filter out matching term (handles object OR string)
      wizzyStore.SEARCHED_TERM = list.filter((item) => {
        if (typeof item === "string") {
          return item.toLowerCase() !== target;
        }

        if (item && typeof item === "object") {
          return (item.searchterm || "").toLowerCase() !== target;
        }

        return true; // keep anything unexpected
      });

      localStorage.setItem("wizzy_store", JSON.stringify(wizzyStore));

      // optional: also remove visually
      link.remove();
    });
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
      function (data) {
        data.facets.forEach((facet) => {
        if(facet.key === "sellingPrice") {
          facet.buckets = [
              { from: 0, to: 199 },
              { from: 200, to: 399 },
              { from: 400, to: 599 },
              { from: 600, to: 899 },
              { from: 900 },
            ];
        }
      })
        // console.log("BEFORE_SEARCH_EXECUTED");
        document.body.classList.add("wizzy-search");
        document.body.classList.remove("wizzy-collection");
        $(".wizzy-collection-des").css({
          display: "none",
        });
        document.body.classList.remove("search-open");
        let search_close = document.querySelector(".search-close-mobile");
        if (search_close) {
          search_close.click();
        }
        const alreadyExists1 = data.sort?.some(
            (s) =>
                s.field === "product_wizzy-best-selling_sortOrder:float" &&
                s.order === "asc"
        );
        if (
            !alreadyExists1 &&
            data.sort?.[0]?.field === "relevance"
        ) {
            data.sort.push({
                field: "product_wizzy-best-selling_sortOrder:float",
                order: "asc"
            });
        }
        data.attributeFacetValuesLimit = 50;
        return data;
      }
    );
    function initSortFilterBottomBehavior() {
      const clientBar = document.querySelector(".mob-bottom-header-container");
      const sortEl = document.querySelector(".wizzy-search-sort-wrapper");
      const filterEl = document.querySelector(".wizzy-mobile-filter-button");
      const wrapper = document.querySelector(".wizzy-search-wrapper");

      if (!clientBar || !sortEl || !filterEl || !wrapper) return;

      // function moveToBottom() {
      //   sortEl.classList.add("sf-at-bottom");
      //   filterEl.classList.add("sf-at-bottom");
      //   if(window.innerWidth < 769)
      //   {
      //     let quickFilters = document.querySelector('.wizzy-quick-filters-wrapper');
      //     if(quickFilters)
      //     {
      //       quickFilters.style.display = "none";
      //     }
      //   }
        

      //   wrapper.classList.remove("has-filters-button-at-top");
      // }

      // function restoreToTop() {
      //   sortEl.classList.remove("sf-at-bottom");
      //   filterEl.classList.remove("sf-at-bottom");
      //   if(window.innerWidth < 769)
      //   {
      //     let quickFilters = document.querySelector('.wizzy-quick-filters-wrapper');
      //     if(quickFilters)
      //     {
      //       quickFilters.style.display = "flex";
      //     }
      //   }
        

      //   wrapper.classList.add("has-filters-button-at-top");
      // }
      function moveToBottom() {
        sortEl.classList.add("sf-at-bottom");
        filterEl.classList.add("sf-at-bottom");

        if (window.innerWidth < 769) {
            setTimeout(() => {
              const quickFilters = document.querySelector('.wizzy-quick-filters-wrapper');
              if (quickFilters) {
                  quickFilters.classList.add("is-hidden");
              }
            }, 100);
            
        }

        wrapper.classList.remove("has-filters-button-at-top");
    }

    function restoreToTop() {
        sortEl.classList.remove("sf-at-bottom");
        filterEl.classList.remove("sf-at-bottom");

        if (window.innerWidth < 769) {
          setTimeout(() => {
            const quickFilters = document.querySelector('.wizzy-quick-filters-wrapper');
            if (quickFilters) {
                quickFilters.classList.remove("is-hidden");
            }
          }, 100);
        }

        wrapper.classList.add("has-filters-button-at-top");
    }



      const observer = new MutationObserver(() => {
        const hidden = clientBar.classList.contains("is-hidden");
        hidden ? moveToBottom() : restoreToTop();
      });

      observer.observe(clientBar, {
        attributes: true,
        attributeFilter: ["class"],
      });

      // initial state
      if (clientBar.classList.contains("is-hidden")) moveToBottom();
    }
    function initCollectionTagsAlignment() {
      const containers = document.querySelectorAll('.collection-tags');
      // console.log("containers", containers);
      if (!containers || !containers.length) return;

      containers.forEach(container => {
          if (!container || !container.children || !container.children.length) {
              return;
          }

          let childrenWidth = 0;

          Array.from(container.children).forEach(el => {
              if (!el || typeof el.offsetWidth !== 'number') return;
              childrenWidth += el.offsetWidth;
          });

          if (!container.clientWidth) return;

          if (childrenWidth > container.clientWidth) {
              container.classList.remove('centered');
              container.classList.add('left');
          } else {
              container.classList.remove('left');
              container.classList.add('centered');
          }
      });
  }
  function initBottomSortSync() {
      const bottomSort = document.querySelector(
          '.wz-mobile-bottom-filter-sort .wz-bottom-sort-selector'
      );

      if (!bottomSort) return;

      if (bottomSort.__wizzyClickHandler) {
          bottomSort.removeEventListener('click', bottomSort.__wizzyClickHandler);
      }

      bottomSort.__wizzyClickHandler = function () {
          const topSort = document.querySelector(
              '.wizzy-search-sort-wrapper .wizzy-common-select-selector'
          );
          if (topSort) topSort.click();
      };

      bottomSort.addEventListener('click', bottomSort.__wizzyClickHandler);
  }
  function initCloseSortSync() {
      const closeSort = document.querySelector(
          ".wizzy-search-wrapper .close-modal"
      );

      if (!closeSort) return;

      if (closeSort.__wizzyClickHandler) {
          closeSort.removeEventListener("click", closeSort.__wizzyClickHandler);
      }

      closeSort.__wizzyClickHandler = function () {
          const sortBtn = document.querySelector(
              ".wizzy-search-sort-wrapper .wizzy-common-select-selector"
          );
          if (sortBtn) {
              sortBtn.click();
          }
      };
      closeSort.addEventListener("click", closeSort.__wizzyClickHandler);
  }


    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
      function (data) {
        if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "blind-books-2026")
        {
          document.body.classList.add('wz-blind-book');
        }
        if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "pre-order-now")
        {
          document.body.classList.add('wz-pre-order');
        }
        try {
          if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "pre-order-now")
          {
            $('.release-timer').each(function () {
              const $timer = $(this);
              const $product = $timer.closest('.product-item');
              const releaseDate = $timer.data('release');
              const releaseTime = new Date(releaseDate).getTime();
              const $countdown = $timer.find('.countdown');

              if (isNaN(releaseTime)) return;

              let interval;

              function updateCountdown() {
                const now = Date.now();
                let diff = releaseTime - now;

                if (diff <= 0) {
                  $product.closest('.wizzy-result-product').remove();
                  if (interval) clearInterval(interval); 
                  return;
                }

                const days = Math.floor(diff / 86400000);
                const hours = Math.floor((diff % 86400000) / 3600000);
                const minutes = Math.floor((diff % 3600000) / 60000);
                const seconds = Math.floor((diff % 60000) / 1000);

                $countdown.text(
                  `${days}d : ${hours}h : ${minutes}m : ${seconds}s`
                );
              }

              updateCountdown(); // First run
              interval = setInterval(updateCountdown, 1000); // Then assign
            });
            document.querySelectorAll(
              '.wizzy-search-wrapper .product-item-container .product-item-content-container .cart-icon'
            ).forEach(el => {
              const textEl = el.querySelector('span');

              if (textEl && textEl.textContent.trim() !== 'Pre-Order Now') {
                textEl.textContent = 'Pre-Order Now';
              }
            });
          }
        } catch (error) {
          console.log(error);
        }
        
        
        // window.iWish.init();
        // let bottom_sort = document.querySelector('.wz-mobile-bottom-filter-sort .wz-bottom-sort-selector');
        // if(bottom_sort)
        // {
        //   bottom_sort.addEventListener('click', function(){
        //     let top_sort = document.querySelector('.wizzy-search-sort-wrapper .wizzy-common-select-selector');
        //     if(top_sort)
        //     {
        //       top_sort.click();
        //     }
        //   });
        // }
        initBottomSortSync();
        if (window.wizzyConfig?.common?.isOnCategoryPage) {
          let collection_title = window.wizzyConfig?.common?.categoryName;
          if (collection_title) {
            let ele = document.querySelector(".collection-title");
            if (ele) {
              ele.textContent = collection_title;
            }
          }
        }
        


        





        
        initSortFilterBottomBehavior();
        initWizzyQuickProductTypeFilters();
        renderGenreTagsFromFacets();
        // let qtySelector = window.iWishData.quantity_selector!='' ? window.iWishData.quantity_selector : '[name=quantity]';
        // let wishlist_elements = document.querySelectorAll('.iWishAddColl');
        // if(wishlist_elements)
        // {
        //   wishlist_elements.forEach((el) => {
        //     el.addEventListener('click', event => {
        //       event.preventDefault();
        //       window.iwishAddProxy.click = "true";
        //       let qtySelect = this.findAncestor(el, qtySelector);
        //       let qty = qtySelect ? parseInt(qtySelect.value) : 1;
        //       let pId = el.getAttributeNode("data-product").value;
        //       let vId = el.getAttributeNode("data-variant").value;
        //       if(pId=='' || vId=='') { return; }
        //       if(isInWishlist(vId)) { // remove if added
        //         this.iwishRemove(vId, pId);
        //         this.setIwishRemoved(el);
        //         if(this.logs) { console.log("iwishRemove::",pId,vId); }
        //         window.changeDetect.status = 'removed';
        //       }
        //       else { // add to wishlist
        //         this.iwishAdd(vId,pId,qty);
        //         this.setIwishAdded(el);
        //         if(this.logs) { console.log("iwishAdd::",pId,vId); }
        //         window.changeDetect.status = 'added';
        //       }
        //     });
        //   })
        // }
        
        // let close_sort = document.querySelector(
        //   ".wizzy-search-wrapper .close-modal"
        // );
        // if (close_sort) {
        //   close_sort.addEventListener("click", function () {
        //     let sort_btn = document.querySelector(
        //       ".wizzy-search-sort-wrapper .wizzy-common-select-selector"
        //     );
        //     if (sort_btn) {
        //       sort_btn.click();
        //     }
        //   });
        // }
        initCloseSortSync();
        // if (window.innerWidth < 769) {

        //   const mobileFilterBtn = document.querySelector(
        //       '.wizzy-mobile-filter-button'
        //   );

        //   const sortWrapper = document.querySelector(
        //       '.wizzy-search-sort-wrapper'
        //   );

        //   // If top already stored on window → reuse it
        //   if (window.__wizzyMobileTop) {

        //       if (mobileFilterBtn) {
        //           mobileFilterBtn.style.top = window.__wizzyMobileTop;
        //       }

        //       if (sortWrapper) {
        //           sortWrapper.style.top = window.__wizzyMobileTop;
        //       }

        //   } else {

        //       let summary, wrapper;

        //       if (window.wizzyConfig?.common?.isOnCategoryPage) {
        //           summary = document.querySelector('.collection-header-section');
        //           wrapper = document.querySelector('.wizzy-search-wrapper');
        //       } else {
        //           // setTimeout(() => {
        //             summary = document.querySelector('.wizzy-search-summary-wrapper');
        //             console.log("summary", summary);
        //             wrapper = document.querySelector('.wizzy-search .wizzy-search-wrapper');
        //           // }, 500);
        //       }

        //       if (summary && wrapper) {
                  
        //           const summaryRect = summary.getBoundingClientRect();
        //           const wrapperRect = wrapper.getBoundingClientRect();

        //           const relativeTop = (summaryRect.bottom - wrapperRect.top);
        //           const newTop = relativeTop + 'px';
        //           console.log("New Top", newTop);
        //           // store once on window
        //           window.__wizzyMobileTop = newTop;

        //           if (mobileFilterBtn) {
        //               mobileFilterBtn.style.top = newTop;
        //           }

        //           if (sortWrapper) {
        //               sortWrapper.style.top = newTop;
        //           }
        //       }
        //   }
        // }
        if (window.innerWidth < 769) {

            const mobileFilterBtn = document.querySelector(
                '.wizzy-mobile-filter-button'
            );

            const sortWrapper = document.querySelector(
                '.wizzy-search-sort-wrapper'
            );

            // If top already stored on window → reuse it
            if (window.__wizzyMobileTop) {
                if (mobileFilterBtn) {
                    mobileFilterBtn.style.top = window.__wizzyMobileTop;
                }
                if (sortWrapper) {
                    sortWrapper.style.top = window.__wizzyMobileTop;
                }
            } else {
                let summary, wrapper;
                if (window.wizzyConfig?.common?.isOnCategoryPage) {
                    summary = document.querySelector('.collection-header-section');
                    wrapper = document.querySelector('.wizzy-search-wrapper');
                    if (summary && wrapper) {
                        applyTop(summary, wrapper);
                    }
                } else {
                    // 🔧 MINOR CHANGE: delay only for search page
                    setTimeout(() => {
                        summary = document.querySelector('.wizzy-search-summary-wrapper');
                        wrapper = document.querySelector('.wizzy-search .wizzy-search-wrapper');
                        if (summary && wrapper) {
                            applyTop(summary, wrapper);
                        }
                    }, 100); // small delay, not random large value
                }
            }
            function applyTop(summary, wrapper) {
                const summaryRect = summary.getBoundingClientRect();
                const wrapperRect = wrapper.getBoundingClientRect();

                const relativeTop = (summaryRect.bottom - wrapperRect.top);
                const newTop = relativeTop + 'px';
                window.__wizzyMobileTop = newTop;
                if (mobileFilterBtn) {
                    mobileFilterBtn.style.top = newTop;
                }

                if (sortWrapper) {
                    sortWrapper.style.top = newTop;
                }
            }
        }
        const wrapper = document.querySelector(
          ".filters-list-top-values-wrapper"
        );

        function toggleWrapper() {
          if (!wrapper || !wrapper.textContent.trim()) {
            wrapper.style.display = "none";
          } else {
            wrapper.style.display = "";
          }
        }

        // Run initially
        toggleWrapper();

        // Run again if content changes dynamically
        const observer = new MutationObserver(toggleWrapper);
        wrapper &&
          observer.observe(wrapper, { childList: true, subtree: true });
        document.addEventListener("click", function (e) {
          const facet = e.target.closest(".wizzy-filters-facet-block");
          if (facet) {
            facet.scrollIntoView({
              behavior: "smooth",
              inline: "center",
              block: "nearest",
            });
            const valuesWrapper = document.querySelector(
              ".filters-list-top-values-wrapper"
            );
            if (valuesWrapper) {
              valuesWrapper.style.display = "none";
            }
            setTimeout(() => {
              const facetKey = facet.getAttribute("data-key");
              const facetRect = facet.getBoundingClientRect();
              const facetLeft = facetRect.left + window.scrollX;

              const valuesWrapper = document.querySelector(
                ".filters-list-top-values-wrapper"
              );
              if (valuesWrapper) {
                valuesWrapper.style.position = "absolute";
                valuesWrapper.style.left = facetLeft + "px";
                valuesWrapper.setAttribute("data-active-facet", facetKey);
              }
              valuesWrapper.style.display = "block";
            }, 300);
          }
        });

        // if (
        //   window.wizzyConfig.common.isOnCategoryPage &&
        //   collectionsToHideSortBy?.includes(
        //     window.wizzyConfig.common.collectionHandle
        //   )
        // ) {
        //   const searchFiltersTopWrapper = document.querySelector(
        //     ".search-filters-top-wrapper"
        //   );
        //   const body = document.querySelector("body");
        //   if (searchFiltersTopWrapper && body) {
        //     searchFiltersTopWrapper.style.display = "none";
        //     if (!body.classList.contains("hide-collection-title")) {
        //       body.classList.add("hide-collection-title");
        //     }
        //   }
        // }
        if (
          window.wizzyConfig.common.isOnCategoryPage &&
          window.wizzyConfig.common.collectionHandle == "crossword-e-gift-cards"
        ) {
          document.body.classList.add("gift-collections");
        } else {
          document.body.classList.remove("gift-collections");
        }

        if (
          typeof window.iwishCheckColl !== "undefined" &&
          typeof window.iwishCheckColl === "function"
        ) {
          window.iwishCheckColl();
        }
        // $(".iWishAddColl").on("click", function (e) {
        //   console.log("Wish Btn is clicked");
        //   e.preventDefault();
        //   var iWishvId = $(this).attr("data-variant");
        //   console.log(iWishvId);
        //   window.iwish_addCollection($(this), iWishvId);
        //   // return false; // This line is redundant; returning false already prevents the default action.
        // });
        document.querySelectorAll(".iwish-btn").forEach((el) => {
          if (window.iwishAddClick) {
            iwishAddClick(el);
          }
        });
        document.addEventListener('DOMContentLoaded', initCollectionTagsAlignment);
        // console.log(data, "event4");
        return data;
      },
      3
    );
    // function normalizeDate(str) {
    //   return str
    //     .replace(/(\d+)(st|nd|rd|th)/i, '$1')
    //     .replace(/february/i, 'Feb');
    // }

    // const normalizedDate = normalizeDate(releaseDate);
    // const releaseTime = new Date(normalizedDate).getTime();

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
      function (data) {
        if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "blind-books-2026")
        {
          document.body.classList.add('wz-blind-book');
        }
        if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "pre-order-now")
        {
          document.body.classList.add('wz-pre-order');
        }
        if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "pre-order-now")
        {
          $('.release-timer').each(function () {
            const $timer = $(this);
            const $product = $timer.closest('.product-item');
            const releaseDate = $timer.data('release');
            const releaseTime = new Date(releaseDate).getTime();
            const $countdown = $timer.find('.countdown');

            if (isNaN(releaseTime)) return;

            function updateCountdown() {
              const now = Date.now();
              let diff = releaseTime - now;

              if (diff <= 0) {
                $product.hide();
                clearInterval(interval);
                return;
              }

              const days = Math.floor(diff / 86400000);
              const hours = Math.floor((diff % 86400000) / 3600000);
              const minutes = Math.floor((diff % 3600000) / 60000);
              const seconds = Math.floor((diff % 60000) / 1000);

              $countdown.text(
                `${days}d : ${hours}h : ${minutes}m : ${seconds}s`
              );
            }

            updateCountdown();
            const interval = setInterval(updateCountdown, 1000);
          });
          document.querySelectorAll(
            '.wizzy-search-wrapper .product-item-container .product-item-content-container .cart-icon'
          ).forEach(el => {
            const textEl = el.querySelector('span');

            if (textEl && textEl.textContent.trim() !== 'Pre-Order Now') {
              textEl.textContent = 'Pre-Order Now';
            }
          });
        }
        // window.iWish.init();
        document.body.classList.add('wizzy-search-results-rendered');
        initBottomSortSync();
        let bg_filter = document.querySelector('.wizzy-progress-bg.for-filter');
        if(bg_filter)
        {
          bg_filter.style.display = "none";
        }
        if(window.wizzyConfig?.common?.isOnCategoryPage)
        {
          document.body.classList.add('wizzy-collection');
        }
        else
        {
          document.body.classList.add('wizzy-search');
        }
        if (window.wizzyConfig?.common?.isOnCategoryPage) {
          let collection_title = window.wizzyConfig?.common?.categoryName;
          if (collection_title) {
            let ele = document.querySelector(".collection-title");
            if (ele) {
              ele.textContent = collection_title;
            }
          }
        }
        // if (window.innerWidth < 769) {

        //   const mobileFilterBtn = document.querySelector(
        //       '.wizzy-mobile-filter-button'
        //   );

        //   const sortWrapper = document.querySelector(
        //       '.wizzy-search-sort-wrapper'
        //   );

        //   // If top already stored on window → reuse it
        //   if (window.__wizzyMobileTop) {

        //       if (mobileFilterBtn) {
        //           mobileFilterBtn.style.top = window.__wizzyMobileTop;
        //       }

        //       if (sortWrapper) {
        //           sortWrapper.style.top = window.__wizzyMobileTop;
        //       }

        //   } else {

        //       let summary, wrapper;

        //       if (window.wizzyConfig?.common?.isOnCategoryPage) {
        //           summary = document.querySelector('.collection-header-section');
        //           wrapper = document.querySelector('.wizzy-search-wrapper');
        //       } else {
        //           summary = document.querySelector('.wizzy-search-summary-wrapper');
        //           wrapper = document.querySelector('.wizzy-search .wizzy-search-wrapper');
        //       }

        //       if (summary && wrapper) {

        //           const summaryRect = summary.getBoundingClientRect();
        //           const wrapperRect = wrapper.getBoundingClientRect();

        //           const relativeTop = (summaryRect.bottom - wrapperRect.top) + 30;
        //           const newTop = relativeTop + 'px';

        //           // store once on window
        //           window.__wizzyMobileTop = newTop;

        //           if (mobileFilterBtn) {
        //               mobileFilterBtn.style.top = newTop;
        //           }

        //           if (sortWrapper) {
        //               sortWrapper.style.top = newTop;
        //           }
        //       }
        //   }
        // }


        initCollectionTagsAlignment();
        initSortFilterBottomBehavior();
        initWizzyQuickProductTypeFilters();
        renderGenreTagsFromFacets();
        // let qtySelector = window.iWishData.quantity_selector!='' ? window.iWishData.quantity_selector : '[name=quantity]';
        // let wishlist_elements = document.querySelectorAll('.iWishAddColl');
        // if(wishlist_elements)
        // {
        //   wishlist_elements.forEach((el) => {
        //     el.addEventListener('click', event => {
        //       event.preventDefault();
        //       window.iwishAddProxy.click = "true";
        //       let qtySelect = this.findAncestor(el, qtySelector);
        //       let qty = qtySelect ? parseInt(qtySelect.value) : 1;
        //       let pId = el.getAttributeNode("data-product").value;
        //       let vId = el.getAttributeNode("data-variant").value;
        //       if(pId=='' || vId=='') { return; }
        //       if(isInWishlist(vId)) { // remove if added
        //         this.iwishRemove(vId, pId);
        //         this.setIwishRemoved(el);
        //         if(this.logs) { console.log("iwishRemove::",pId,vId); }
        //         window.changeDetect.status = 'removed';
        //       }
        //       else { // add to wishlist
        //         this.iwishAdd(vId,pId,qty);
        //         this.setIwishAdded(el);
        //         if(this.logs) { console.log("iwishAdd::",pId,vId); }
        //         window.changeDetect.status = 'added';
        //       }
        //     });
        //   })
        // }

        // let close_sort = document.querySelector(
        //   ".wizzy-search-wrapper .close-modal"
        // );
        // if (close_sort) {
        //   close_sort.addEventListener("click", function () {
        //     let sort_btn = document.querySelector(
        //       ".wizzy-common-select-selector"
        //     );
        //     if (sort_btn) {
        //       sort_btn.click();
        //     }
        //   });
        // }
        initCloseSortSync();
        if (window.innerWidth < 769) {

            const mobileFilterBtn = document.querySelector(
                '.wizzy-mobile-filter-button'
            );

            const sortWrapper = document.querySelector(
                '.wizzy-search-sort-wrapper'
            );

            // If top already stored on window → reuse it
            if (window.__wizzyMobileTop) {
                if (mobileFilterBtn) {
                    mobileFilterBtn.style.top = window.__wizzyMobileTop;
                }
                if (sortWrapper) {
                    sortWrapper.style.top = window.__wizzyMobileTop;
                }
            } else {
                let summary, wrapper;
                if (window.wizzyConfig?.common?.isOnCategoryPage) {
                    summary = document.querySelector('.collection-header-section');
                    wrapper = document.querySelector('.wizzy-search-wrapper');
                    if (summary && wrapper) {
                        applyTop(summary, wrapper);
                    }
                } else {
                    // 🔧 MINOR CHANGE: delay only for search page
                    setTimeout(() => {
                        summary = document.querySelector('.wizzy-search-summary-wrapper');
                        wrapper = document.querySelector('.wizzy-search .wizzy-search-wrapper');
                        if (summary && wrapper) {
                            applyTop(summary, wrapper);
                        }
                    }, 100); // small delay, not random large value
                }
            }
            function applyTop(summary, wrapper) {
                const summaryRect = summary.getBoundingClientRect();
                const wrapperRect = wrapper.getBoundingClientRect();

                const relativeTop = (summaryRect.bottom - wrapperRect.top);
                const newTop = relativeTop + 'px';
                window.__wizzyMobileTop = newTop;
                if (mobileFilterBtn) {
                    mobileFilterBtn.style.top = newTop;
                }

                if (sortWrapper) {
                    sortWrapper.style.top = newTop;
                }
            }
        }
        const wrapper = document.querySelector(
          ".filters-list-top-values-wrapper"
        );

        function toggleWrapper() {
          if (!wrapper || !wrapper.textContent.trim()) {
            wrapper.style.display = "none";
          } else {
            wrapper.style.display = "";
          }
        }

        // Run initially
        toggleWrapper();

        // Run again if content changes dynamically
        const observer = new MutationObserver(toggleWrapper);
        wrapper &&
          observer.observe(wrapper, { childList: true, subtree: true });
        document.addEventListener("click", function (e) {
          const facet = e.target.closest(".wizzy-filters-facet-block");
          if (facet) {
            facet.scrollIntoView({
              behavior: "smooth",
              inline: "center",
              block: "nearest",
            });
            const valuesWrapper = document.querySelector(
              ".filters-list-top-values-wrapper"
            );
            if (valuesWrapper) {
              valuesWrapper.style.display = "none";
            }
            setTimeout(() => {
              const facetKey = facet.getAttribute("data-key");
              const facetRect = facet.getBoundingClientRect();
              const facetLeft = facetRect.left + window.scrollX;

              const valuesWrapper = document.querySelector(
                ".filters-list-top-values-wrapper"
              );
              if (valuesWrapper) {
                valuesWrapper.style.position = "absolute";
                valuesWrapper.style.left = facetLeft + "px";
                valuesWrapper.setAttribute("data-active-facet", facetKey);
              }
              valuesWrapper.style.display = "block";
            }, 300);
          }
        });

        // if (
        //   window.wizzyConfig.common.isOnCategoryPage &&
        //   collectionsToHideSortBy?.includes(
        //     window.wizzyConfig.common.collectionHandle
        //   )
        // ) {
        //   const searchFiltersTopWrapper = document.querySelector(
        //     ".search-filters-top-wrapper"
        //   );
        //   const body = document.querySelector("body");
        //   if (searchFiltersTopWrapper && body) {
        //     searchFiltersTopWrapper.style.display = "none";
        //     if (!body.classList.contains("hide-collection-title")) {
        //       body.classList.add("hide-collection-title");
        //     }
        //   }
        // }
        if (
          window.wizzyConfig.common.isOnCategoryPage &&
          window.wizzyConfig.common.collectionHandle == "crossword-e-gift-cards"
        ) {
          document.body.classList.add("gift-collections");
        } else {
          document.body.classList.remove("gift-collections");
        }

        if (
          typeof window.iwishCheckColl !== "undefined" &&
          typeof window.iwishCheckColl === "function"
        ) {
          window.iwishCheckColl();
        }
        // $(".iWishAddColl").on("click", function (e) {
        //   console.log("Wish Btn is clicked");
        //   e.preventDefault();
        //   var iWishvId = $(this).attr("data-variant");
        //   console.log(iWishvId);
        //   window.iwish_addCollection($(this), iWishvId);
        //   // return false; // This line is redundant; returning false already prevents the default action.
        // });
        document.querySelectorAll(".iwish-btn").forEach((el) => {
          if (window.iwishAddClick) {
            iwishAddClick(el);
          }
        });

        // console.log(data, "event4");
        return data;
      }
    );
  };
  window.onWizzyLoaded.push(wizzyEvents1);

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      window.wizzyConfig.filters.configs.layout = "v2";
      // data.search.configs.pagination.appendInExistingList = !0;
      window.wizzyConfig.store.currency.symbol = "AED";
      try {
        window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
          desktop: 1000,
          mobile: 1600,
        };
        window.wizzyConfig.search.configs.facets.filtersButtonMobile.position =
          "top";
        window.wizzyConfig.search.view.templates.facets.rangeListItem =
          "#wizzy-facet-range-list-item";
        window.wizzyConfig.search.configs.facets.configs =
          window.wizzyConfig.search.configs.facets.configs.filter(
            (facet) => facet.key !== "sellingPrice"
          );
        window.wizzyConfig.search.configs.facets.configs.push({
          label: "Price",
          buckets: [
            {
              from: 0,
              to: 199,
            },
            {
              from: 200,
              to: 399,
            },
            {
              from: 400,
              to: 599,
            },
            {
              from: 600,
              to: 899,
            },
            {
              from: 900,
            },
          ],
          key: "sellingPrice",
          position: "left",
          order: 50,
        });
      } catch (error) {}
      // console.log(data, "<<<before init");
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.general.minQueryLength = 1;

      data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: ".search-bar input",
        type: "text",
      };
      data.search.configs.noProductsFound.defaultPool.data.productsCount = 50;
      var currentURL = window.location.href;
      data.common.lazyDOMConfig.contentDOMIdentifiers.push("main");
      if (currentURL.includes("/collection")) {
        const identifiers = data.common.lazyDOMConfig.contentDOMIdentifiers;
        const indexToRemove = identifiers.indexOf("main");

        if (indexToRemove !== -1) {
          identifiers.splice(indexToRemove, 1);
        }
      }
      // data.common.lazyDOMConfig.contentDOMIdentifiers = ["main"];

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      window.wizzyConfig.filters.configs.layout = "v2";
      // data.search.configs.pagination.appendInExistingList = !0;
      try {
        window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
          desktop: 1000,
          mobile: 1600,
        };
        window.wizzyConfig.search.configs.facets.filtersButtonMobile.position =
          "top";
        window.wizzyConfig.search.view.templates.facets.rangeListItem =
          "#wizzy-facet-range-list-item";
        window.wizzyConfig.search.configs.facets.configs =
          window.wizzyConfig.search.configs.facets.configs.filter(
            (facet) => facet.key !== "sellingPrice"
          );
        window.wizzyConfig.search.configs.facets.configs.push({
          label: "Price",
          buckets: [
            {
              from: 0,
              to: 199,
            },
            {
              from: 200,
              to: 399,
            },
            {
              from: 400,
              to: 599,
            },
            {
              from: 600,
              to: 899,
            },
            {
              from: 900,
            },
          ],
          key: "sellingPrice",
          position: "left",
          order: 50,
        });
      } catch (error) {}
      // console.log(data, "<<<before init");
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.general.minQueryLength = 1;

      data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: ".search-bar input",
        type: "text",
      };
      data.search.configs.noProductsFound.defaultPool.data.productsCount = 50;
      var currentURL = window.location.href;
      data.common.lazyDOMConfig.contentDOMIdentifiers.push("main");
      if (currentURL.includes("/collection")) {
        const identifiers = data.common.lazyDOMConfig.contentDOMIdentifiers;
        const indexToRemove = identifiers.indexOf("main");

        if (indexToRemove !== -1) {
          identifiers.splice(indexToRemove, 1);
        }
      }
      // data.common.lazyDOMConfig.contentDOMIdentifiers = ["main"];

      return data;
    }
  );

  $(document).on("click", " .wizzy-apply-all-button", (e) => {
    $(".wizzy-filters-bg").click();
  });

  function isPresentInURL(params) {
    let url = window.location.href;
    return url.includes(params);
  }


  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      // console.log("BEFORE_FILTERS_EXECUTED", data);
      if (window.wizzyConfig.common.isOnCategoryPage) {
        document.body.classList.remove("wizzy-search");
        document.body.classList.add("wizzy-collection");
      }
      else
      {
        document.body.classList.add("wizzy-search");
        document.body.classList.remove("wizzy-collection");
      }
      if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "blind-books-2026")
      {
        document.body.classList.add('wz-blind-book');
      }
      if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "pre-order-now")
      {
        document.body.classList.add('wz-pre-order');
      }
      data.filters.attributeFacetValuesLimit = 50;
      if (window.location.href.includes("/collection")) {
        data.filters.showOOSProductsInOrder = "true";
      }
      // console.log("data4444", data);
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      data.facets.forEach((facet) => {
        if(facet.key === "sellingPrice") {
          facet.buckets = [
              { from: 0, to: 199 },
              { from: 200, to: 399 },
              { from: 400, to: 599 },
              { from: 600, to: 899 },
              { from: 900 },
            ];
        }
      })
      // console.log(data.facets);
      // console.log("BEFORE_SEARCH_EXECUTED");
      window.__wizzyMobileTop = undefined;
      document.body.classList.add('wizzy-search');
      document.body.classList.remove('wizzy-collection');
      document.body.classList.remove('wz-pre-order');
      document.body.classList.remove('wz-blind-book');

      // console.log(data);

      return data;
    },3
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      // window.iWish.init();
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      let x = document.querySelector(".wizzy-body-end-wrapper");
      if (
        x &&
        typeof data.isForDefault !== "undefined" &&
        data.isForDefault === true
      ) {
        x.classList.add("wizzy-view-more-hide");
      } else if (x && x.classList.contains("wizzy-view-more-hide")) {
        x.classList.remove("wizzy-view-more-hide");
      }
      return data;
    }
  );
  // const inputFields = document.querySelectorAll(".wizzy-search-input");
  // console.log(inputFields)=
  //  inputFields.forEach((inputField) => {
  //    inputField.addEventListener("input", () => {
  //      setTimeout(() => {
  //        // console.log("inside input")
  //        const viewMoreButton = document.querySelector(
  //          "button.btn.btn--small.wizzy-autocomplete-top-products-view-more"
  //        );
  //        if (inputField.value.length === 0 && viewMoreButton) {
  //          // viewMoreButton.classList.add("wizzy-display-none");
  //          viewMoreButton.style.display = "none";
  //        } else if (viewMoreButton) {
  //          // viewMoreButton.classList.add("wizzy-display-block");
  //          viewMoreButton.style.display = "block";
  //        }
  //      }, 1000);
  //    });
  //  });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      // // Get the input element by its class name
      // var inputElement = document.querySelector(".wizzy-search-input");

      // // Check the length of the input value
      // var inputValueLength = inputElement.value.length;

      // // Output the length to the console
      // console.log("Input value length: " + inputValueLength);
      // console.log("AFTER_PRODUCTS_TRANSFORMED", data);

      let currentURL = window.location.href;
      data.forEach((product) => {
        let attributes = product.attributes;
        let author = "";
        let brand = "";
        let isBeyondBooks = false;
        let isBooks = false;
        let dis = 0;
        
        attributes.forEach((attribute) => {
          if (attribute.id == "product_books_author_1_custom") {
            author = attribute.values[0].value[0];
          }
          if(attribute.id == "product_scheduled_date_custom") {
            product.dateofPub = attribute.values[0].value[0];
          }

          if (attribute.id == "product_genre_shopify") {
            product.category_genre = attribute.values;
          }

          if (attribute.id == "product_producttype_custom") {
            let value = attribute.values[0].value[0];
            if (value === "Books") {
              product.isBook = true;
            }
          }
          if (attribute.id == "product_primary_genre_custom") {
            product.primary_genre = attribute.values[0].value[0];
          }
          if (attribute.id == "product_brand_custom") {
            product.brand_name = attribute.values[0].value[0];
          }

          if (attribute.id == "product_brand_Products") {
            brand = attribute.values[0].value[0];
          }

          if (
            attribute.id == "product_tags" &&
            attribute.values[0].value[0].includes("Beyond Books")
          ) {
            isBeyondBooks = true;
          }

          if (
            attribute.id == "product_tags" &&
            attribute.values[0].value[0].includes("Books")
          ) {
            isBooks = true;
          }
          if (
            attribute.id == "product_value_tags_discount_wizzy_backend" &&
            attribute.values[0].value[0] == "10%OFF"
          ) {
            dis = 10;
          }
          if (
            attribute.id == "product_value_tags_discount_wizzy_backend" &&
            attribute.values[0].value[0] == "15%OFF"
          ) {
            dis = 15;
          }
          if (
            attribute.id == "product_value_tags_discount_wizzy_backend" &&
            attribute.values[0].value[0] == "20%OFF"
          ) {
            dis = 20;
          }
          if (
            attribute.id == "product_value_tags_discount_wizzy_backend" &&
            attribute.values[0].value[0] == "25%OFF"
          ) {
            dis = 25;
          }

          if (
            attribute.id == "product_value_tags_discount_wizzy_backend" &&
            (attribute.values[0].value[0] == "30%OFF" ||
              attribute.values[0].value[0] == "30% OFF")
          ) {
            dis = 30;
          }

          if (
            attribute.id == "product_value_tags_discount_wizzy_backend" &&
            attribute.values[0].value[0] == "50%OFF"
          ) {
            dis = 50;
          }

          if (
            attribute.id == "product_tags" &&
            attribute.values[0].value[0].includes("30%OFF")
          ) {
            dis = 30;
          }

          if (
            attribute.id == "product_tags" &&
            attribute.values[0].value[0].includes("25%OFF")
          ) {
            dis = 25;
          }

          if (
            attribute.id == "product_tags" &&
            attribute.values[0].value[0].includes("20%OFF")
          ) {
            dis = 20;
          }

          if (
            attribute.id == "product_tags" &&
            attribute.values[0].value[0].includes("15%OFF")
          ) {
            dis = 15;
          }

          if (
            attribute.id == "product_tags" &&
            attribute.values[0].value[0].includes("10%OFF")
          ) {
            dis = 10;
          }

          if (
            attribute.id == "product_tags" &&
            attribute.values[0].value[0].includes("50%OFF")
          ) {
            dis = 50;
          }

          if (
            attribute.id == "product_tags" &&
            (attribute.values[0].value[0].includes("Preorder") ||
              attribute.values[0].value[0].includes("pre-order"))
          ) {
            product.preorder = true;
          }
          // if(attribute.id == "product_tags")
          // {
          //   console.log(attribute.values[0].value[0],"pppppppppppppppppppppppp");
          // }
        });

        product.author = author;
        if (product.price) product.price = product.price.split(".")[0];
        if (product.sellingPrice)
          product.sellingPrice = product.sellingPrice.split(".")[0];

        if (window.wizzyConfig.common.isOnCategoryPage) {
          product.isoncollectionpage = true;
        }

        // console.log(product.sellingPrice,"<<pp=======")
        let sellingPrice = Number(
          parseFloat(product.sellingPrice.replace(/,/g, ""))
        );
        // console.log(sellingPrice - sellingPrice * 0.1,"<<=======")

        if (dis === 10) {
          // console.log(String(sellingPrice - sellingPrice * 0.1), "String");
          // let temp=
          product.newSellingPrice = Number(
            String(sellingPrice - sellingPrice * 0.1 + 0.0).split(".")[0]
          ).toLocaleString();
          product.discountPercentage = 10;
        }
        if (dis === 15) {
          // console.log(String(sellingPrice - sellingPrice * 0.15), "String");
          // let temp=
          product.newSellingPrice = Number(
            String(sellingPrice - sellingPrice * 0.15 + 0.0).split(".")[0]
          ).toLocaleString();
          product.discountPercentage = 15;
        }

        if (dis === 20) {
          product.newSellingPrice = Number(
            String(sellingPrice - sellingPrice * 0.2 + 0.0).split(".")[0]
          ).toLocaleString();
          product.discountPercentage = 20;
        }

        if (dis === 25) {
          product.newSellingPrice = Number(
            String(sellingPrice - sellingPrice * 0.25 + 0.0).split(".")[0]
          ).toLocaleString();
          product.discountPercentage = 25;
        }

        if (dis === 30) {
          product.newSellingPrice = Number(
            String(sellingPrice - sellingPrice * 0.3 + 0.0).split(".")[0]
          ).toLocaleString();
          product.discountPercentage = 30;
        }

        if (dis === 50) {
          product.newSellingPrice = Number(
            String(sellingPrice - sellingPrice * 0.5 + 0.0).split(".")[0]
          ).toLocaleString();
          product.discountPercentage = 50;
        }
        if(product.discountPercentage)
        {
          let wz_price = product.price;
          let wz_sellingPrice = product.sellingPrice;
          let numA = parseFloat(wz_price.replace(/,/g, ""));
          let numB = parseFloat(wz_sellingPrice.replace(/,/g, ""));
          product.discountPrice = numA - numB;
          // console.log(product.price,product.sellingPrice,product.discountPrice);
        }
      });

      data.forEach((product) => {
        product.giftCardAvailable = false;
        if (product.attributes) {
          product.attributes.forEach((attribute) => {
            if (attribute.id === "product_product_type") {
              if (
                attribute.values[0].value[0] &&
                attribute.values[0].value[0] === "qwikcilver_gift_card"
              ) {
                product.giftCardAvailable = true;
                if (!window.wizzyConfig.common.isOnCategoryPage) {
                  product.url =
                    "https://www.crossword.in/products/crossword-gift-card";
                }
              }
            }
          });
        }
      });

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      return data;
    }
  );
  //   $(document).on("submit", ".wizzy-cart-form", function (event) {
  //     event.preventDefault();

  //     var form = $(this);
  //     var id = form.find('input[name="id"]').val();
  //     var quantity = form.find('input[name="quantity"]').val();

  //     console.log(quantity, "<<<=======");
  //     if (quantity != "0") {
  //       console.log(quantity, "<<<=======");
  //       var payload = {
  //         id: id,
  //         quantity: 1,
  //       };

  //       $.ajax({
  //         url: "https://www.crossword.in/cart/add.js",
  //         method: "POST",
  //         data: JSON.stringify(payload),
  //         dataType: "json",
  //         contentType: "application/json", // Set the Content-Type header
  //         success: function (response) {
  //           console.log("POST request successful:", response);
  //         },
  //         error: function (error) {
  //           console.error("POST request failed:", error);
  //         },
  //       });

  //       console.log("prevent default");
  //       setTimeout(function () {
  //         theme.updateCartSummaries(true);
  //       }, 500);
  //     }
  //   });
  //   $(document).on("click", ".product-item-author", function (event) {
  //     event.preventDefault();
  //     event.stopImmediatePropagation();
  //     let str = event.target.innerText;
  //     let authName = "";
  //     for (let i = 0; i < str.length; i++) {
  //       if (str[i] == " " && i > 0 && i < str.length - 1) {
  //         // Replace space between characters
  //         authName += "-";
  //       } else {
  //         authName += str[i].toLowerCase();
  //       }
  //     }
  //     window.location.href = `https://www.crossword.in/collections/${authName}`;
  //     console.log(event.target.innerText, "<== will not happen.");
  //   });

  //   changeTemplate("wizzy-search-results-product");
  //   changeTemplate("wizzy-search-empty-results");
  //   changeTemplate("wizzy-collection-empty-results");

  //   if (document.documentElement.clientWidth > 768) {
  //     changeTemplate("wizzy-autocomplete-topproducts");
  //   } else {
  //     const oldDiv = document.getElementById("wizzy-autocomplete-topproducts");
  //     const newDiv = document.getElementById(
  //       "mobile-wizzy-autocomplete-topproducts-new"
  //     ).text;

  //     oldDiv.text = newDiv;

  //     changeTemplate("wizzy-search-wrapper");
  //   }
};

// const changeTemplate = function (div) {
//   console.log(div);
//   const oldDiv = document.getElementById(div);
//   const newDiv = document.getElementById(div + "-new")?.text;

//   oldDiv.text = newDiv;
// };
